import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 登录
interface LoginInfoData {
	username: string,
	password: string
}
export const LoginInfo = (json: LoginInfoData): any => http.httpPost({
	url: httpApi.loginHome.LoginInfo,
	json,
})

// 登出
interface LogoutJson {
	token: string,
}
export const logout = (json: LogoutJson): any => $fn.httpPost({
	url: httpApi.loginHome.logout,
	json
})

// 获取手机号验证码
interface GetPhoneCodeData {
	phone: string
}
export const getPhoneCode = (json: GetPhoneCodeData): any => http.httpPost({
	url: httpApi.loginHome.getPhoneCode,
	json
})

// 校验手机验证码
interface CheckPhoneCode {
	phone: string,
	code: string
}
export const checkPhoneCode = (json: CheckPhoneCode): any => http.httpPost({
	url: httpApi.loginHome.checkPhoneCode,
	json
})

// 登录,账号不存在则注册
interface JudgePhoneLogin {
	phone: string,
	promote_code: string,
	code: string
}
export const judgePhoneLogin = (json: JudgePhoneLogin): any => http.httpPost({
	url: httpApi.loginHome.judgePhoneLogin,
	json
})

// 账号名密码登陆 不存在则注册一个
interface LoginOrRegJson {
	username: string,
	password: string,
}
export const loginOrReg = (json: LoginOrRegJson): any => http.httpPost({
	url: httpApi.loginHome.loginOrReg,
	json
})

// 账号名密码登陆 不存在则注册一个
interface PhoneLoginJson {
	phone: string,
	promote_code: string,
	code: string
}
export const phoneLogin = (json: PhoneLoginJson): any => http.httpPost({
	url: httpApi.loginHome.phoneLogin,
	json
})


// 绑定手机号
interface BindPhoneJson {
	username: string,
	password: string,
	phone: string,
	code: string
}
export const bindPhone = (json: BindPhoneJson): any => http.httpPost({
	url: httpApi.loginHome.bindPhone,
	json
})

// 校验手机号是否存在
interface CheckPhoneExistJson {
	phone: string,
}
export const checkPhoneExist = (json: CheckPhoneExistJson): any => http.httpPost({
	url: httpApi.loginHome.checkPhoneExist,
	json
})

// 解绑手机-校验验证码，并生成修改token
interface CheckUnbindPhoneCodeJson {
	phone: string,
	code: string
}
export const checkUnbindPhoneCode = (json: CheckUnbindPhoneCodeJson): any => http.httpPost({
	url: httpApi.loginHome.checkUnbindPhoneCode,
	json
})

// 解绑手机-根据token解绑手机
interface UnbindPhoneByTokenJson {
	phone: string,
	unbind_token: string,
	uid: number,
}
export const unbindPhoneByToken = (json: UnbindPhoneByTokenJson): any => http.httpPost({
	url: httpApi.loginHome.unbindPhoneByToken,
	json
})

// 根据用户名获取手机号前四位
interface GetPhonePreByUsernameJson {
	username: string,
}
export const getPhonePreByUsername = (json: GetPhonePreByUsernameJson): any => http.httpPost({
	url: httpApi.loginHome.getPhonePreByUsername,
	json
})

// 根据用户名查询手机号
interface GetPhoneByUsernameJson {
	username: string,
}
export const getPhoneByUsername = (json: GetPhoneByUsernameJson): any => http.httpPost({
	url: httpApi.loginHome.getPhoneByUsername,
	json
})

// 用户名密码注册
interface SecondVersoinJson {
	username: string,
	password: string,
	device_id: string,
}
export const secondVersoin = (json: SecondVersoinJson): any => http.httpPost({
	url: httpApi.loginHome.secondVersoin,
	json
})

// 用户名密码登陆
interface LoginbypwdJson {
	username: string,
	password: string,
}
export const loginbypwd = (json: LoginbypwdJson): any => http.httpPost({
	url: httpApi.loginHome.loginbypwd,
	json
})

// 手机验证码登陆
interface PhoneRegisterJson {
	phone: string,
	code: string,
}
export const phoneRegister = (json: PhoneRegisterJson): any => http.httpPost({
	url: httpApi.loginHome.phoneRegister,
	json
})

// token绑定手机号
interface BindPhoneByTokenJson {
	bind_phone_token: string,
	phone: string,
	code: string,
}
export const bindPhoneByToken = (json: BindPhoneByTokenJson): any => http.httpPost({
	url: httpApi.loginHome.bindPhoneByToken,
	json
})

// 账号密码注册-带验证码
interface RegisterUnameJson {
	phone: string,
	code: string,
}
export const registerUname = (json: RegisterUnameJson): any => http.httpPost({
	url: httpApi.loginHome.registerUname,
	json
})

interface RegisterSliderJson {
	username: string,
	password: string,
	sessionid: string,
	nctoken: string,
	sig: string,
	scene: string,
}

// 用户名密码注册接口-带滑块验证
export const registerSlider = (json: RegisterSliderJson): any => http.httpPost({
	url: httpApi.loginHome.registerSlider,
	json
})

// 用户名密码登陆-带滑块验证
export const bypassword = (json: RegisterSliderJson): any => http.httpPost({
	url: httpApi.loginHome.bypassword,
	json
})
